"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteDistributorSuggestedProduct = void 0;
const routes_1 = require("../../routes");
const deleteDistributorSuggestedProduct = (client) => async (params, payload) => {
    const response = await client.delete(routes_1.ENDPOINTS.DELETE_DISTRIBUTOR_SUGGESTED_PRODUCTS.applyParams(params), { data: payload });
    return response.data;
};
exports.deleteDistributorSuggestedProduct = deleteDistributorSuggestedProduct;
